import React, { useState , useEffect} from 'react';
import { FaPlus } from "react-icons/fa6";



const ByobProductCards = ({ product , index , handleAddToTray, trayData }) => {

  const [isActive, setIsActive] = useState(false)


  useEffect(() => {
    console.log("Card State" , isActive)
  }, [isActive])


  const handleGoToProduct = () => {
    // window.location.href = `/products/${product.handle}`;
  }

  const secondaryImage = product.images[1]?.medium || product.image;

    return (
      <div className="mb-2 col-span-1 md:col-span-3 relative group p-5 md:h-[400px] flex flex-col" onClick={() => handleGoToProduct()} onMouseEnter={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)}>
        <div className="relative aspect-square w-full flex-shrink-0">
          <img 
            src={product.image} 
            alt={product.title} 
            className='w-full h-full object-cover group-hover:opacity-0 transition-all duration-300'
          />
          
          <img 
            src={secondaryImage} 
            alt={product.title} 
            className='absolute inset-0 w-full h-full object-cover rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300'
          />
        </div>

        <button 
          onClick={(e) => { 
            e.stopPropagation(); 
            handleAddToTray(product)
          }}  
          className={`
            absolute top-[120px] lg:!top-[calc(100%-125px)]  right-[30px] hover:shadow-xl 
            ease-in-out duration-300 px-[8px] py-2 border-2 bg-none  
            text-white rounded-full ${trayData.length === 5 ? 'bg-gray-500' : 'bg-white'}
            ${isActive ? 'opacity-100' : 'opacity-100 md:hidden'}
            transition-all duration-300
          `}
          disabled={trayData.length === 5}
        >
          <FaPlus size={20} color={`${trayData.length === 5 ? 'gainsboro' : 'black'}`}/>
        </button>
        
        <div className="text-center mt-4 flex-grow">
          <h3 className="text-[12.96px] text-[#726e75] font-[500] line-clamp-2">{product.title}</h3>
          <p className="text-[12.96px] mt-1">{product.price}</p>
        </div>
      </div>
    )
}

export default ByobProductCards;